document.addEventListener("DOMContentLoaded", () => {
    const isInstalmentsCalculator = !!document.querySelector(".instalments-calculator");
    if (!isInstalmentsCalculator) return;

    const hearingAidCategoryList = document.querySelector(".ha-category").dataset.classes.split(",");
    const hearingAidCategorySlider = document.querySelector(".ha-category__slider");
    const hearingAidCategoryTooltip = document.querySelector(".ha-category__tooltip");

    const instalmentsSlider = document.querySelector(".instalments__slider");
    const instalmentsTooltip = document.querySelector(".instalments__tooltip");

    const insuranceCheckbox = document.querySelector("#insurance-checkbox");
    const monthlyPaymentEl = document.querySelector(".monthly-payment__amount");
    const productList = document.querySelectorAll(".product");
    const productTotalPrice = document.querySelector(".product__total-price");

    let selectedCategory;
    let selectedInstalments;
    let insuranceCoverage;
    let productPrice;

    hearingAidCategorySlider.addEventListener("input", () => {
        updateCategory();
        setTooltip(hearingAidCategorySlider, hearingAidCategoryTooltip, selectedCategory);
    });

    instalmentsSlider.addEventListener("input", () => {
        updateInstalments();
        setTooltip(instalmentsSlider, instalmentsTooltip, selectedInstalments);
    });

    insuranceCheckbox.addEventListener("change", setInsuranceCoverage);

    function updateCategory() {
        selectedCategory = hearingAidCategoryList[hearingAidCategorySlider.value];
        displayProduct();
        getPrice();
        calcTotalPrice();
        calcMonthlyPayment();
    }

    function updateInstalments() {
        selectedInstalments = instalmentsSlider.value;
        calcMonthlyPayment();
    }

    function setInsuranceCoverage() {
        insuranceCoverage = insuranceCheckbox.checked ? insuranceCheckbox.dataset.amount : 0;
        calcTotalPrice();
        calcMonthlyPayment();
    }

    function getPrice() {
        productList.forEach((product) => {
            if (product.dataset.productCategory === selectedCategory) {
                productPrice = product.dataset.price;
            }
        });
    }

    function calcTotalPrice() {
        let total = productPrice - insuranceCoverage;
        productTotalPrice.innerHTML = total;
    }

    function calcMonthlyPayment() {
        let monthlyPayment = (productPrice - insuranceCoverage) / selectedInstalments;
        monthlyPaymentEl.innerHTML = Math.floor(monthlyPayment > 0 ? monthlyPayment : 0);
    }

    function displayProduct() {
        productList.forEach((product) => {
            product.classList.remove("active");
            product.dataset.productCategory === selectedCategory && product.classList.add("active");
        });
    }

    function setTooltip(range, tooltip, innerVal) {
        const { value, min = 0, max = 100 } = range;
        const newVal = ((value - min) * 100) / (max - min);
        range.style.backgroundSize = ((value - min) * 100) / (max - min) + "% 100%";
        tooltip.style.left = `calc(${newVal}% + (${12.5 - newVal * 0.26}px))`;
        tooltip.querySelector(".tooltip-text").innerHTML = innerVal;
    }

    updateCategory();
    updateInstalments();
    calcTotalPrice();
    setInsuranceCoverage();
    getPrice();
    calcMonthlyPayment();

    setTooltip(hearingAidCategorySlider, hearingAidCategoryTooltip, selectedCategory);
    setTooltip(instalmentsSlider, instalmentsTooltip, selectedInstalments);
});
